import { render, staticRenderFns } from "./ReadArticles.vue?vue&type=template&id=4a3a8b5c&scoped=true"
import script from "./ReadArticles.vue?vue&type=script&lang=js"
export * from "./ReadArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3a8b5c",
  null
  
)

export default component.exports